import request from '../../utils/request';

export default id => request(`/pre-settlement-requests/${id}`);
